export default class ConfirmDirective
{
    static getDefinition(dialogInstance) {
        return {
            bind: (el, binding) => {

                let clickNode = function (node) {
                    if (document.createEvent) {
                        let evt = document.createEvent('MouseEvents')
                        evt.initEvent('click', true, false)
                        node.dispatchEvent(evt)
                    } else if (document.createEventObject) {
                        node.fireEvent('onclick')
                    } else if (typeof node.onclick === 'function') {
                        node.onclick()
                    }
                }

                let dialogClickHanlder = (event, el, binding) => {
                    event.preventDefault()
                    event.stopImmediatePropagation()

                    let confirmMessage
                    let options = {}
                    let component = undefined

                    if( typeOf(binding.value) === 'function' ) {
                        binding.value = binding.value()
                    }

                    if( isObject(binding.value) ) {
                        options = binding.value

                        if( options.component !== undefined ) {
                            component = options.component
                            options = options.options
                        }
                    } else {
                        confirmMessage = binding.value
                    }

                    let thenCallback = (dialog, el) => {
                        // Unbind to allow original event
                        el.removeEventListener('click', el.dialogClickHandler, true)

                        // Trigger original event
                        clickNode(el)

                        // Re-bind listener
                        el.addEventListener('click', el.dialogClickHandler, true)
                    }

                    let cancelCallback = () => {
                        //  do nothing
                    }

                    if( options.ok !== undefined ) {
                        thenCallback = options.ok
                        options.close = false
                    }

                    if( options.cancel !== undefined ) {
                        cancelCallback = options.cancel
                    }

                    // handle modifiers
                    if( options.type === undefined ) {
                        let modalType = 'default'
                        if( binding.modifiers.danger ) modalType = 'danger'
                        if( binding.modifiers.info ) modalType = 'info'
                        if( binding.modifiers.success ) modalType = 'success'
                        if( binding.modifiers.warning ) modalType = 'warning'

                        options.type = modalType
                    }
                    //

                    dialogInstance
                        .confirm(confirmMessage, options, component)
                        .then((dialog) => {
                            return thenCallback(dialog, el)
                        })
                        .catch(cancelCallback)
                }

                el.dialogClickHandler = event => dialogClickHanlder(event, el, binding)

                el.addEventListener('click', el.dialogClickHandler, true)
            },
            unbind: (el) => {
                el.removeEventListener('click', el.dialogClickHandler, true)
            }
        }
    }
}
